/**
 * Reia — mega nav Book an Appointment popup + OTP
 * Moved out of snippets/reia-mega-nav-panel-book-appointment.liquid (was inline on every page) so it is cached between page views.
 */
var REIA_SHOP = window.reiaShopDomain || '';
  (function() {
    var overlay = document.getElementById('apptPopupOverlay');
    var form = document.getElementById('megaNavApptForm');
    if (!overlay || !form) return;

    /* ── Open / Close ── */
    function openPopup() {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closePopup() {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }

    // Trigger buttons (desktop + mobile)
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-open-appt-popup]')) {
        e.preventDefault();
        openPopup();
      }
    });

    // Close button
    overlay.querySelector('[data-close-appt-popup]').addEventListener('click', closePopup);

    // Stop all clicks on the overlay from reaching the mega nav behind
    overlay.addEventListener('click', function(e) {
      e.stopPropagation();
      if (e.target === overlay) closePopup();
    });

    // Escape key — only handles the main overlay now (OTP dialog handles Escape via 'cancel' event)
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      if (!navOtpModal.open && overlay.classList.contains('active')) {
        closePopup();
      }
    });

    /* ── reCAPTCHA lazy-load ── */
    form.addEventListener('focusin', function() {
      if (window.loadRecaptcha) window.loadRecaptcha();
    }, { once: true });

    /* ── Date min = today ── */
    var dateInput = form.querySelector('input[type="date"]');
    if (dateInput) {
      var today = new Date().toISOString().split('T')[0];
      dateInput.setAttribute('min', today);
    }

    /* ── Phone auto-format ── */
    var phoneInput = document.getElementById('megaNavApptForm-whatsapp');
    if (phoneInput) {
      phoneInput.addEventListener('input', function() {
        var digits = this.value.replace(/\D/g, '').slice(0, 10);
        if (digits.length > 5) {
          this.value = digits.slice(0, 5) + ' ' + digits.slice(5);
        } else {
          this.value = digits;
        }
      });
    }

    /* ── OTP state & helpers ── */
    var otpPhone = '';
    var otpTimerInterval = null;
    var navOtpModal    = document.getElementById('nav-otp-modal');
    var navOtpInput    = document.getElementById('nav-otp-input');
    var navOtpError    = document.getElementById('nav-otp-error');
    var navOtpVerify   = document.getElementById('nav-otp-verify-btn');
    var navOtpResend   = document.getElementById('nav-otp-resend-btn');
    var navOtpSubtitle = document.getElementById('nav-otp-subtitle');
    var navOtpClose    = document.getElementById('nav-otp-close');
    var otpSendUrl     = '/apps/reia-booking/api/otp/send?shop=' + REIA_SHOP;
    var otpVerifyUrl   = '/apps/reia-booking/api/otp/verify?shop=' + REIA_SHOP;

    function openNavOtpModal(phone) {
      var digits = phone.replace('+91', '');
      navOtpSubtitle.textContent = 'We sent a 6-digit code to +91 ' + digits.slice(0,5) + ' ' + digits.slice(5) + ' on WhatsApp.';
      navOtpInput.value = '';
      navOtpError.textContent = '';
      navOtpModal.showModal(); // enters browser top layer — appears above all dialogs
      setTimeout(function() { navOtpInput.focus(); }, 100);
      startNavOtpTimer();
    }
    function closeNavOtpModal() {
      navOtpModal.close();
      clearInterval(otpTimerInterval);
    }

    // Handle Escape key via dialog's cancel event (re-enable submit button)
    if (navOtpModal) {
      navOtpModal.addEventListener('cancel', function(e) {
        e.preventDefault(); // we handle close ourselves
        closeNavOtpModal();
        var btn = form.querySelector('.appt-cta__submit-btn');
        if (btn) { btn.disabled = false; btn.textContent = form.dataset.originalBtnText || 'Confirm Appointment'; }
      });
    }
    function startNavOtpTimer() {
      var secs = 60;
      navOtpResend.disabled = true;
      navOtpResend.textContent = 'Resend in ' + secs + 's';
      clearInterval(otpTimerInterval);
      otpTimerInterval = setInterval(function() {
        secs--;
        navOtpResend.textContent = secs > 0 ? 'Resend in ' + secs + 's' : 'Resend code';
        if (secs <= 0) { clearInterval(otpTimerInterval); navOtpResend.disabled = false; }
      }, 1000);
    }

    if (navOtpClose) {
      navOtpClose.addEventListener('click', function() {
        closeNavOtpModal();
        var btn = form.querySelector('.appt-cta__submit-btn');
        if (btn) { btn.disabled = false; btn.textContent = form.dataset.originalBtnText || 'Confirm Appointment'; }
      });
    }
    if (navOtpResend) {
      navOtpResend.addEventListener('click', function() {
        navOtpResend.disabled = true;
        navOtpError.textContent = '';
        fetch(otpSendUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: otpPhone }) })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            if (res.success) { navOtpInput.value = ''; navOtpError.textContent = ''; startNavOtpTimer(); }
            else { navOtpError.textContent = res.error || 'Unable to resend.'; navOtpResend.disabled = false; }
          })
          .catch(function() { navOtpError.textContent = 'Unable to resend.'; navOtpResend.disabled = false; });
      });
    }
    if (navOtpInput) {
      navOtpInput.addEventListener('input', function() { this.value = this.value.replace(/\D/g,'').slice(0,6); });
      navOtpInput.addEventListener('keydown', function(e) { if (e.key === 'Enter' && navOtpVerify) navOtpVerify.click(); });
    }
    if (navOtpVerify) {
      navOtpVerify.addEventListener('click', function() {
        var code = navOtpInput.value.trim();
        if (code.length !== 6) { navOtpError.textContent = 'Please enter the 6-digit code.'; return; }
        navOtpError.textContent = '';
        navOtpVerify.disabled = true;
        navOtpVerify.textContent = 'Verifying…';
        fetch(otpVerifyUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: otpPhone, code: code }) })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            if (res.success) {
              form.dataset.otpVerified = 'true';
              form.dataset.otpVerifiedPhone = otpPhone;
              closeNavOtpModal();
              if (typeof dataLayer !== 'undefined') {
                dataLayer.push({ event: 'nav_otp_verified', form_name: 'mega_nav_appointment' });
              }
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            } else {
              navOtpError.textContent = res.error || 'Incorrect code. Please try again.';
              navOtpVerify.disabled = false;
              navOtpVerify.textContent = 'Verify & Book';
            }
          })
          .catch(function() {
            navOtpError.textContent = 'Verification failed. Please try again.';
            navOtpVerify.disabled = false;
            navOtpVerify.textContent = 'Verify & Book';
          });
      });
    }

    /* ── Form submit ── */
    var endpoint = '/apps/reia-booking/api/leads?shop=' + REIA_SHOP;

    function validateForm() {
      var nameInput = document.getElementById('megaNavApptForm-name');
      var phoneEl = document.getElementById('megaNavApptForm-whatsapp');
      var dateField = document.getElementById('megaNavApptForm-date');
      var honeypot = document.getElementById('megaNavApptForm-website');

      if (honeypot && honeypot.value !== '') return false;
      if (window.reiaIsTooFastSubmission()) return false;

      if (nameInput && nameInput.value.trim().length < 2) {
        alert('Please enter your full name');
        nameInput.focus();
        return false;
      }

      var phoneValue = phoneEl.value.replace(/\D/g, '');
      if (phoneValue.length !== 10) {
        alert('Please enter a valid 10-digit mobile number.');
        phoneEl.focus();
        return false;
      }

      if (dateField && !dateField.value) {
        alert('Please select a date for your appointment');
        dateField.focus();
        return false;
      }

      var timeSelect = document.getElementById('megaNavApptForm-time');
      if (timeSelect && !timeSelect.value) {
        alert('Please select a preferred time slot');
        timeSelect.focus();
        return false;
      }

      return true;
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!validateForm()) return;

      var btn = form.querySelector('.appt-cta__submit-btn');
      var errorEl = document.getElementById('megaNavApptForm-error');
      var successEl = document.getElementById('megaNavApptForm-success');
      var originalText = btn.textContent;
      form.dataset.originalBtnText = originalText;

      // ── OTP gate ──
      var phoneEl = document.getElementById('megaNavApptForm-whatsapp');
      var rawDigits = phoneEl ? phoneEl.value.replace(/\D/g, '') : '';
      var currentPhone = rawDigits.length === 10 ? '+91' + rawDigits : '';
      var alreadyVerified = form.dataset.otpVerified === 'true' && form.dataset.otpVerifiedPhone === currentPhone;
      if (!alreadyVerified && currentPhone) {
        otpPhone = currentPhone;
        btn.disabled = true;
        btn.textContent = 'Sending OTP…';
        fetch(otpSendUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone: otpPhone }) })
          .then(function(r) { return r.json(); })
          .then(function(res) {
            if (res.success) {
              openNavOtpModal(otpPhone);
            } else {
              btn.disabled = false; btn.textContent = originalText;
              errorEl.textContent = res.error || 'Unable to send OTP. Please try again.';
              errorEl.classList.add('active');
            }
          })
          .catch(function() {
            btn.disabled = false; btn.textContent = originalText;
            errorEl.textContent = 'Unable to send OTP. Please try again.';
            errorEl.classList.add('active');
          });
        return;
      }
      // ── end OTP gate ──

      errorEl.classList.remove('active');
      btn.disabled = true;
      btn.textContent = 'Verifying...';

      function submitForm(recaptchaToken) {
        btn.textContent = 'Submitting...';
        var formData = new FormData(form);

        var rawPhone = formData.get('Whatsapp_Number');
        var phone = rawPhone ? ('+91' + rawPhone.replace(/\D/g, '')) : '';

        var sessionId = (typeof crypto !== 'undefined' && crypto.randomUUID)
          ? crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2);

        var payload = {
          session_id: sessionId,
          name: formData.get('Name'),
          phone: phone,
          date: formData.get('Consultation_Date'),
          time: formData.get('Preferred_Time'),
          form_type: 'appointment',
          page_url: window.location.href,
          metadata: window.reiaGetClickAttribution ? window.reiaGetClickAttribution() : undefined
        };

        fetch(endpoint, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
        })
        .then(function(response) {
          return response.json().then(function(data) {
            return { ok: response.ok, data: data };
          }).catch(function() {
            return { ok: response.ok, data: null };
          });
        })
        .then(function(result) {
          if (result.ok) {
            form.style.display = 'none';
            successEl.classList.add('active');
            if (typeof dataLayer !== 'undefined') {
              dataLayer.push({ event: 'form_submit', form_name: 'mega_nav_appointment' });
            }
          } else {
            throw new Error('Submission failed');
          }
        })
        .catch(function() {
          errorEl.classList.add('active');
          btn.disabled = false;
          btn.textContent = originalText;
        });
      }

      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
          grecaptcha.execute('6LfipqIsAAAAABITdYfx8kF8DFNLLE0Scp86vjnj', { action: 'submit' })
            .then(function(token) { submitForm(token); })
            .catch(function() { submitForm(null); });
        });
      } else {
        submitForm(null);
      }
    });
  })();
